import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

import {
  YearFilterValue,
  YearFilterError,
} from 'components/Reporting/Overview/FilterBuilder/Filters/YearsOfBirth/Types'

interface propsTypes {
  yearFilterValue: YearFilterValue
  yearFilterError: YearFilterError
  handleYearEntry: any
}

const YearInput = (props: propsTypes) => {
  const { t } = useTranslation()
  const {
    label: errorLabel,
    state: errorState,
    year_error,
  } = props.yearFilterError

  return (
    <Grid item xs={12}>
      <TextField
        sx={{ width: '100%' }}
        id="standard-error-helper-text"
        label={t('filters.yob.dialogContent.yearEntryLabel')}
        error={errorLabel && errorState && year_error ? true : false}
        helperText={
          errorLabel && errorState && year_error
            ? year_error
            : t('filters.yob.helperTextExample.1984')
        }
        variant="standard"
        type="text"
        onChange={(e) => props.handleYearEntry(e, 'year')}
        value={
          props.yearFilterValue.year == 0 ? '' : props.yearFilterValue.year
        }
        inputProps={{ maxLength: 4 }}
      />
    </Grid>
  )
}
export default YearInput
